import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const HomeRedirect: React.FC = () => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const TENANT_ROLES = ['tenant_admin', 'tenant_support', 'tenant_billing'];
  if (TENANT_ROLES.includes(user.role)) {
    return <Navigate to="/tenant" replace />;
  }

  // All company roles → main dashboard
  return <Navigate to="/dashboard" replace />;
};

export default HomeRedirect;